import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";
import { status } from "../../utils/common";

const state = {
    localities: [],
    locality: {},
    totalItems:0,

};

const getters = {
    index: state => localityId => state.localities.findIndex(i => i.localityId === localityId)
};

const mutations = {
    setLocalities: (state, r) => (state.localities = r),
    setTotalItems: (state, r) => (state.totalItems = r),

    add: (state, r) => state.localities.unshift(r),
    delete: (state, index) => state.localities.splice(index, 1),
    lock: (state, index) => state.localities[index].status = status.locked,
    unlock: (state, index) => state.localities[index].status = status.active,
    setlocality: (state, r) => (state.locality = r),
    edit: (state, { index, r }) => state.localities.splice(index, 1, r),

};

const actions = {
    async getAll({ commit },params) {
        try {
            const paramsString = Object.entries(params)
            .filter(([, val]) => val !== null)
            .map(([key, val]) => `${key}=${val}`)
            .join("&");
            startLoading()
            const response = await dataService.localities.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            commit("setLocalities", response.data.localities);
            commit("setTotalItems", response.data.totalItems);

          
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async add({ commit }, payload) {
        try {
            startLoading()
            const response = await dataService.localities.add(payload);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);
            commit("add", response.data.locality);


        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.localities.delete(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async lock({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.localities.lock(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("lock", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async unlock({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.localities.unlock(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("unlock", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getDetails({ commit }, id) {
        try {
            commit("setlocality", {});
            console.log(id)
            startLoading()
            const response = await dataService.localities.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            commit("setlocality", response.data.locality);
          
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.localities.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            return Promise.resolve(response.data.locality);
          
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async edit({ commit, getters }, { id, payload }) {
        try {
            startLoading()
            const response = await dataService.localities.edit(id, payload);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }


            const index = getters.index(id);
            console.log(index);
            console.log(response.data.locality );
            commit("edit", { index, r: response.data.locality });

            return Promise.resolve()
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
